//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper from 'swiper';

export default {
  name: 'lottie-demo-carousel-item',
  components: {
    LottiePlayer: () => import('@motionelements/core/src/components/ui/players/BaseLottiePlayer.vue'),
  },
  props: {
    animationTypes: Array,
    animationSpeed: Number,
    currentIndex: Number,
    swiperOptions: {
      type: Object,
    },
    arrowsPadding: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      anim: [],
      swiper: null,
      defaultSwiperOptions: {
        slidesPerView: 1,
        spaceBetween: 16,
        // loop: false,
        autoplay: false,
        centerInsufficientSlides: true,
      },
    };
  },
  computed: {
    mergedSwiperOptions() {
      return { ...this.defaultSwiperOptions, ...this.swiperOptions, loop: false };
    },
  },
  watch: {
    animationSpeed() {
      for (var i = 0; i < this.anim.length; i += 1) {
        this.anim[i].setSpeed(this.animationSpeed);
      }
    },
    currentIndex(value) {
      this.slideTo(value);
    },
  },
  mounted() {
    this.initSwiper();
  },
  beforeDestroy() {
    if (this.swiper !== null) {
      console.log('destory swiper');
      this.swiper.destroy();
    }
  },
  methods: {
    registerAnimation: function (anim) {
      anim.setSpeed(this.animationSpeed);
      this.anim.push(anim);
    },
    initSwiper() {
      console.log('init swiper', this.mergedSwiperOptions);
      this.swiper = new Swiper(this.$refs.lottieSwiper, {
        ...this.mergedSwiperOptions,
      });
    },
    slideTo(index) {
      this.swiper.slideTo(index);
    },
  },
};
